module.exports = __webpack_public_path__ + "img/文化理念.8a80a228.png";